import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FormField from '../layout/FormField';
import FormSelect from '../layout/FormSelect';

const Profile = () => {
    const validate = Yup.object({
        first_name: Yup.string().required('Required'),
        last_name: Yup.string().required('Required'),
        role: Yup.string().required('Required'),
        email: Yup.string().email('Email is invalid').required('Required'),
        password: Yup.string().required('Required'),
        retype_password: Yup.string().required('Required')
    });

    const roleData = [
        {
            label: 'Admin',
            value: 'admin'
        },
        {
            label: 'Customer',
            value: 'customer'
        },
        {
            label: 'Tester',
            value: 'tester'
        },
        {
            label: 'Dev',
            value: 'dev'
        }
    ];

    return (
        <Row>
            <Col xs={12} sm={12} md={8} lg={6} className="shadow-sm p-3 m-3">
                <div className="p-5 form_container mx-auto">
                    <Formik
                        initialValues={{
                            first_name: '',
                            last_name: '',
                            role: '',
                            email: '',
                            password: '',
                            retype_password: ''
                        }}
                        validationSchema={validate}
                        onSubmit={(values) => {
                            console.log('Signup Values', values);
                        }}
                    >
                        <Form>
                            <FormField label="First Name" name="first_name" type="text" />
                            <FormField label="Last Name" name="last_name" type="text" />
                            <FormSelect label="Role" name="role" data={roleData} />
                            <FormField label="Email Address" name="email" type="email" />
                            <FormField label="Password" name="password" type="password" />
                            <FormField label="Retype Password" name="retype_password" type="password" />
                            <div className="text-end">
                                <Link to="/districts">
                                    <Button type="submit" className="theme-cancel-btn me-3">
                                        Cancel
                                    </Button>
                                </Link>
                                <Button type="submit" className="theme-btn">
                                    Update
                                </Button>
                            </div>
                        </Form>
                    </Formik>
                </div>
            </Col>
        </Row>
    );
};

export default Profile;
